import Vue from 'vue'
import vuex from 'vuex'
Vue.use(vuex);
import VueCookies from 'vue-cookies'
Vue.use(VueCookies);
import auth from './modules/auth'

export default new vuex.Store({
    state: {
        /* 页数 */
        tabIndex: "1",

        show: false,
        stockMoney: '',
        cardNumber: '',
        freeMoney: '',
        tabbar: VueCookies.get('tabbar') == null ? 0 : VueCookies.get('tabbar'),
    },
    mutations: {
        switch_dialog(state) { //这里的state对应着上面这个state
            this.state.show = state.show ? false : true;
        }
    },
    modules: {
        auth
    }
})


// WEBPACK FOOTER //
// ./src/store/index.js